import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Box,
    Typography,
    IconButton,
    MenuItem,
    Button,
    Paper,
    TextField,
    Grid,
    Pagination,
    Divider,
    Stack,
    Slide,
    Toolbar,
    Dialog,
    CircularProgress
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LaunchIcon from '@mui/icons-material/Launch';
import { useLocation, useNavigate } from 'react-router-dom';
import { makeApiRequest } from '../../../utils/api';
import { formatDate } from "../../../helpers/timeHelper";
import nodata from '../../../assets/nodata.png';
import Nodata from '../../../assets/nodata.png';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const ProjectStaffReview = ({ projectData, onBack }) => {
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedMark, setSelectedMark] = useState();
    const [remarks, setRemarks] = useState('');
    const [assignment, setAssignment] = useState([]);
    const [error, setError] = useState();
    const navigate = useNavigate();
    const { id, submittedAssignments = [] } = location.state || {};
    const [status, setStatus] = useState();
    const [loading, setLoading] = useState(false);
    const [assignStatus, setAssignStatus] = useState("");
    const [open, setOpen] = React.useState(false);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const data = {
                id: id,
                status: status,
                mark: selectedMark,
                remark: remarks
            };
            const response = await makeApiRequest('post', '/api/assignments/status', {
                token: localStorage.getItem('authToken'),
                data: data
            });
            if (!response || response.status !== 'success' || !response.data) {
                throw new Error(response?.message || 'Invalid response from API');
            }
            if (response.status === "success") {
                toast.success("Reviewed successfully");

                // Find the next submitted assignment
                const currentIndex = submittedAssignments.findIndex(a => a.id === id);
                const nextAssignment = submittedAssignments[currentIndex + 1];

                if (nextAssignment) {
                    navigate('/Review-Assignment', {
                        state: {
                            id: nextAssignment.id,
                            submittedAssignments: submittedAssignments
                        }
                    });
                } else {
                    toast.info("No more submitted assignments to review.");
                    navigate('/View-Assignment');
                }
            }
        } catch (err) {
            console.error('Error fetching employee data:', err);
            setError(err.message || 'Error occurred while fetching employee data');
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate('/View-Assignment')
    }


    const handleEdit = () => {
        setStatus(assignment.status || '');
        setSelectedMark(assignment.mark || '');
        setRemarks(assignment.remark || '');
        setAssignStatus("submitted");
    }


    useEffect(() => {
        const fetchAssignmentData = async () => {
            setLoading(true);
            try {
                const response = await makeApiRequest('post', '/api/assignments/id/list', {
                    token: localStorage.getItem('authToken'),
                    id: id
                });


                if (!response || response.status !== 'success' || !response.data) {
                    throw new Error(response?.message || 'Invalid response from API');
                }
                const currentAssignment = response.data[0];
                setAssignment(currentAssignment);
                setAssignStatus(currentAssignment.status);
                
                if (currentAssignment.status === "submitted") {
                    setStatus('');
                    setSelectedMark('');
                    setRemarks('');
                } else {
                    setStatus(currentAssignment.status || '');
                    setSelectedMark(currentAssignment.mark || '');
                    setRemarks(currentAssignment.remark || '');
                }
                setLoading(false);
            } catch (err) {
                console.error('Error fetching assignment data:', err);
                setError(err.message || 'Error occurred while fetching assignment data');
            }
        };
        fetchAssignmentData();
    }, [id]);

    useEffect(() => {
        if (!location.state || !id) {
            navigate('/View-Assignment');
        }
    }, [location, navigate]);


    const handleNext = () => {
        navigate('/Review-Assignment', { state: { id: id + 1 } })
    }


    if (loading) return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
        >
            <CircularProgress
                size={40}
                thickness={4}
                sx={{
                    color: '#481E82',
                }}
            />
        </Box>
    );

    return (
        <Box sx={{ maxWidth: '100%', minHeight: '100vh', p: '24px', backgroundColor: "#F1F4F9", fontFamily: "Roboto", display: "flex", gap: 3 }} >
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <Box sx={{ display: "flex", alignItems: "flex-start", backgroundColor: "#F1F4F9" }}>
                <IconButton
                    onClick={handleBack}
                    sx={{
                        border: "2px solid #1567C1",
                        borderRadius: '4px',
                        width: 40,
                        height: 40,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingLeft: 2,
                        margin: 0,
                        minWidth: "auto",
                    }}
                >
                    <ArrowBackIosIcon sx={{ fontSize: 20 }} />
                </IconButton>
            </Box>

            <Box sx={{ width: "100%" }}>
                {/* Student Info */}
                <Paper
                    sx={{
                        p: 2,
                        mb: 3,
                        bgcolor: '#fff',
                        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                        borderRadius: 1
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3} >
                            <Typography variant="caption" color="textSecondary">
                                Student Name
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: 500,
                                    fontSize: "20px"
                                }}
                            >
                                {assignment?.stud_name || 'N/A'}
                                <Typography style={{ fontSize: "12px", color: "#0091ea" }}> {assignment?.stud_id || 'N/A'}</Typography>

                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="caption" color="textSecondary">
                                Batch / Course
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "20px" }}>
                                {assignment?.batch_name || 'N/A'}
                                <Typography style={{ fontSize: "12px", color: "#0091ea" }}> {assignment?.course_name || 'N/A'}</Typography>

                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="caption" color="textSecondary">
                                Module / Chapter
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "20px" }}>
                                {assignment?.module_name || 'N/A'}
                                <Typography style={{ fontSize: "12px", color: "#0091ea" }}> {assignment?.chapter_name || 'N/A'}</Typography>

                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Grid container >
                                {/* Status Section */}
                                <Grid item xs={assignment.status === "reviewed" ? 6 : 12}>
                                    <Typography variant="caption" color="textSecondary">
                                        Status
                                    </Typography>
                                    <br />
                                    <Button
                                        sx={{
                                            bgcolor: {
                                                reviewed: "#D4BBFC",
                                                assigned: "#FFFFA3",
                                                submitted: "#CBFAF0",
                                                rejected: "#FDE6EB",
                                            }[assignment.status] || "#CBFAF0",

                                            color: {
                                                reviewed: "#421869",
                                                assigned: "#FF8000",
                                                submitted: "#298880",
                                                rejected: "#BA3068",
                                            }[assignment.status] || "#000000",

                                            height: 50,
                                            minWidth: 80,
                                            borderRadius: "4px",

                                            border: `1px solid ${{
                                                reviewed: "#9667E0",
                                                assigned: "#FF9900",
                                                submitted: "#98EEDB",
                                                rejected: "#FCD6DE",
                                            }[assignment.status] || "#98EEDB"
                                                }`,

                                            textTransform: "capitalize",
                                            fontSize: "20px",
                                            padding: "2px 8px",

                                            "&:hover": {
                                                bgcolor: {
                                                    reviewed: "#E6D1FF",
                                                    assigned: "#FFFFCC",
                                                    submitted: "#E1FFF8",
                                                    rejected: "#FFE8F0",
                                                }[assignment.status] || "#D6F7F0",
                                            },
                                        }}
                                        size="large"
                                    >
                                        {assignment.status === "assigned" ? "Pending" : assignment.status}
                                    </Button>
                                </Grid>

                                {/* Marks Section - Only visible if reviewed */}
                                {assignment.status === "reviewed" && (
                                    <Grid item xs={6} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <Paper elevation={3} sx={{ backgroundColor: "#FFEE99", p: 2, textAlign: "center" }}>
                                            <Typography variant="caption" color="textSecondary">
                                                Marks
                                            </Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 500, color: "#1976d2" }}>
                                                {assignment.mark}/10
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="caption" color="textSecondary">
                                Source File Location
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "14px", wordWrap: "break-word" }} > {assignment.source_file_path}</Typography>

                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="caption" color="textSecondary">
                                Project Title
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "14px" }}>
                                {assignment.project_title}

                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="caption" color="textSecondary">
                                Project Description
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "14px", wordWrap: "break-word" }}>
                                {assignment.project_description}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography variant="caption" color="textSecondary">
                                Assigned By
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "20px" }}>
                                {assignment.created_by}
                                <Typography >on <span style={{ fontSize: "14px", color: "#0091ea" }}>{formatDate(assignment.assign_date)}</span></Typography>

                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>

                {/* Project Content and Review Form */}
                {(assignment.status === "submitted" || assignment.status === "reviewed" || assignment.status === "rejected") && (


                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <Paper elevation="4" sx={{ borderRadius: "14px" }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, py: 2, }}>
                                    {/* <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                        File Description
                                    </Typography> */}
                                    <Typography variant="h6" >
                                        {assignment.file_description}
                                    </Typography>
                                    <Box>
                                        <IconButton size="small">
                                            <LaunchIcon onClick={handleClickOpen} sx={{ /* fontSize: 21 */ color: "#3d8bd8" }} />
                                        </IconButton>
                                    </Box>

                                </Box>


                                <Box
                                    sx={{
                                        width: "100%",
                                        minHeight: "250px",
                                        bgcolor: "#EEEEEE",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: 1,
                                        overflow: "hidden",
                                        mb: 2
                                    }}
                                >

                                    {(assignment.status === "assigned") && (
                                        <Box
                                            component="img"
                                            src={Nodata}
                                            // alt="Project content"
                                            sx={{
                                                width: "80%",
                                                height: "auto",
                                            }}
                                        />

                                    )}
                                    {(assignment.status === "submitted" || assignment.status === "reviewed" || assignment.status === "rejected") && (
                                        <Box
                                            sx={{
                                                width: "100%",
                                                minHeight: "100px",
                                                bgcolor: "#EEEEEE",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: 1,
                                                overflow: "hidden",
                                                mb: 2
                                            }}
                                        >
                                            {assignment.input_file_path && assignment.input_file_path.length > 0 ? (
                                                (() => {
                                                    // const fileUrl = `http://127.0.0.1:8000/documents/${assignment.input_file_path[currentPage - 1]}`;
                                                    // const fileUrl = `http://13.235.83.128:8000/documents/${assignment.input_file_path[currentPage - 1]}`;
                                                    // const fileUrl = `http://143.110.191.9/documents/${assignment.input_file_path[currentPage - 1]}`;
                                                    const fileName = assignment.input_file_path[currentPage - 1].split('/').pop();
                                                    const fileUrl = `https://learn.quraltalent.com/documents/${assignment.input_file_path[currentPage - 1]}`;
                                                    // const fileUrl = `http://16.171.0.8/documents/${assignment.input_file_path[currentPage - 1]}`
                                                    const fileExtension = fileUrl.split('.').pop().toLowerCase();

                                                    if (["png", "jpg", "jpeg", "gif"].includes(fileExtension)) {
                                                        return (
                                                            <img
                                                                src={fileUrl}
                                                                alt="Uploaded file"
                                                                style={{ width: "80%", height: "250px", objectFit: "contain" }}
                                                            />
                                                        );
                                                    } else if (fileExtension === "pdf") {
                                                        return (
                                                            <iframe
                                                                src={fileUrl}
                                                                style={{ width: "100%", height: "270px", border: "none" }}
                                                                title="PDF Viewer"
                                                            />
                                                        );
                                                    } else if (["mp3", "wav", "ogg", "m4a", "aac"].includes(fileExtension)) {
                                                        return (
                                                            <Box sx={{
                                                                width: "100%",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                p: 3
                                                            }}>
                                                                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                                                                    Audio File: {fileName}
                                                                </Typography>
                                                                {/* this part */}
                                                                <audio controls src={`http://127.0.0.1:8000/stream-audio/${fileName}`} />
                                                            </Box>
                                                        );
                                                    } else if (["txt", "csv", "log"].includes(fileExtension)) {
                                                        return (
                                                            <iframe
                                                                src={fileUrl}
                                                                style={{ width: "100%", height: "250px", border: "none" }}
                                                                title="Text Viewer"
                                                            />
                                                        );
                                                    }
                                                    else if (["ppt", "pptx"].includes(fileExtension)) {
                                                        return (
                                                            <iframe
                                                                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
                                                                style={{ width: "100%", height: "600px", border: "none" }}
                                                                title="PowerPoint Viewer"
                                                            />
                                                        );
                                                    }
                                                    else {
                                                        return <Typography>No preview available for this file type.</Typography>;
                                                    }
                                                })()
                                            ) : (
                                                <Typography>No file available</Typography>
                                            )}
                                        </Box>

                                    )}

                                </Box>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    mt: 2,
                                    p: 3
                                }}>
                                    {(assignment.status === "submitted" || assignment.status === "reviewd" || assignment.status === "rejected") && (


                                        <Stack spacing={2}>

                                            <Pagination
                                                count={assignment.input_file_path?.length}
                                                page={currentPage}
                                                showFirstButton
                                                showLastButton
                                                onChange={handlePageChange}
                                                // variant="outlined"
                                                // shape="rounded"
                                                sx={{
                                                    '& .MuiPaginationItem-root': {
                                                        mx: 0.5
                                                    },
                                                    '& .Mui-selected': {
                                                        bgcolor: '#9c27b0 !important',
                                                        color: 'white',
                                                        borderRadius: "50%"
                                                    }
                                                }}
                                            />
                                        </Stack>
                                    )}
                                </Box>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={7}>
                            <Box sx={{ px: 3, py: 3, borderRadius: "14px", boxShadow: 2, bgcolor: '#ECECEC' }}>
                                <Grid container spacing={2} >
                                    <Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <Typography variant="h6" style={{ color: "#5E2CA5" }}>
                                            Assign Marks
                                        </Typography>
                                        {(assignStatus === "reviewed" || assignStatus === "rejected") && (
                                            <div style={{ marginLeft: "auto" }}>
                                                <EditIcon onClick={handleEdit} style={{ cursor: "pointer", color: "#1976d2" }} />
                                            </div>
                                        )}
                                        <Divider sx={{ mt: 2 }} />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box >
                                            {(assignStatus === "submitted") && (
                                                <TextField
                                                    select
                                                    fullWidth
                                                    label="Status"
                                                    name="mark"
                                                    value={status}
                                                    onChange={(e) => setStatus(e.target.value)}
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        sx: {
                                                            "& .MuiInputLabel-asterisk": {
                                                                color: "red",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        sx: {
                                                            backgroundColor: "white",
                                                        },
                                                    }}
                                                    SelectProps={{
                                                        displayEmpty: true,
                                                        fullWidth: true,
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left",
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left",
                                                            },
                                                            getContentAnchorEl: null,
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="" disabled sx={{ color: "grey" }}>
                                                        Select Status
                                                    </MenuItem>
                                                    <MenuItem value="reviewed"> Reviewed</MenuItem>
                                                    <MenuItem value="rejected"> Rejected</MenuItem>
                                                </TextField>

                                            )}
                                            {(assignStatus === "reviewed" || assignStatus === "rejected") && (
                                                <TextField
                                                    fullWidth
                                                    label="Status"
                                                    name="mark"
                                                    value={assignment.status}
                                                    // onChange={(e) => setStatus(e.target.value)}
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    InputProps={{
                                                        sx: {
                                                            backgroundColor: "white",
                                                            "& input": {
                                                                textTransform: "capitalize",
                                                            }
                                                        },
                                                    }}
                                                />
                                            )}

                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>

                                        <Box >
                                            {(assignStatus === "submitted") && (
                                                <TextField
                                                    select
                                                    fullWidth
                                                    label="Mark"
                                                    name="mark"
                                                    value={selectedMark}
                                                    onChange={(e) => setSelectedMark(e.target.value)}
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        sx: {
                                                            "& .MuiInputLabel-asterisk": {
                                                                color: "red",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        sx: {
                                                            backgroundColor: "white",
                                                        },
                                                    }}
                                                    SelectProps={{
                                                        displayEmpty: true,
                                                        fullWidth: true,
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left",
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left",
                                                            },
                                                            getContentAnchorEl: null,
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="0/10" disabled sx={{ color: "grey" }}>
                                                        Assign Mark
                                                    </MenuItem>
                                                    {[...Array(10)].map((_, i) => (
                                                        <MenuItem key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            )}
                                            {(assignStatus === "reviewed") && (
                                                <TextField
                                                    fullWidth
                                                    label="Mark"
                                                    name="mark"
                                                    value={`${assignment?.mark}/10`}
                                                    onChange={(e) => setSelectedMark(e.target.value)}
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        sx: {
                                                            "& .MuiInputLabel-asterisk": {
                                                                color: "red",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        sx: {
                                                            backgroundColor: "white",
                                                        },
                                                    }}
                                                    SelectProps={{
                                                        displayEmpty: true,
                                                        fullWidth: true,
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left",
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left",
                                                            },
                                                            getContentAnchorEl: null,
                                                        },
                                                    }}
                                                >
                                                </TextField>
                                            )}
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {(assignStatus === "submitted") && (
                                            <Box sx={{ mb: 3, width: "100%" }}>
                                                <TextField
                                                    multiline
                                                    rows={4}
                                                    fullWidth
                                                    label="Remarks"
                                                    name="remarks"
                                                    value={remarks}
                                                    onChange={(e) => setRemarks(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            bgcolor: '#fff',
                                                            paddingBottom: "40px",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <Box sx={{
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                gap: 1,
                                                                position: "absolute",
                                                                bottom: 8,
                                                                right: 8,
                                                                width: "100%",
                                                                flexWrap: "wrap",
                                                                mb: 1
                                                            }}>
                                                                <Button
                                                                    onClick={() => setRemarks((prev) => prev + ' Promising start!')}
                                                                    sx={{
                                                                        bgcolor: '#FFEE99',
                                                                        color: '#A47E1B',
                                                                        height: 24,
                                                                        minWidth: 80,
                                                                        borderRadius: '4px',
                                                                        border: "1px solid #FFD400",
                                                                        textTransform: 'none',
                                                                        fontSize: '0.75rem',
                                                                        padding: '2px 8px',
                                                                        '&:hover': { bgcolor: '#FFE082' }
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    Promising start!
                                                                </Button>
                                                                <Button
                                                                    onClick={() => setRemarks((prev) => prev + ' Good Job!')}
                                                                    sx={{
                                                                        bgcolor: '#CBFAF0',
                                                                        color: '#298880',
                                                                        height: 24,
                                                                        minWidth: 80,
                                                                        borderRadius: '4px',
                                                                        border: "1px solid #98EEDB",
                                                                        textTransform: 'none',
                                                                        fontSize: '0.75rem',
                                                                        padding: '2px 8px',
                                                                        '&:hover': { bgcolor: '#B3E5D8' }
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    Good Job!
                                                                </Button>
                                                                <Button
                                                                    onClick={() => setRemarks((prev) => prev + ' Needs improvement.')}
                                                                    sx={{
                                                                        bgcolor: '#FDE6EB',
                                                                        color: '#BA3068',
                                                                        height: 24,
                                                                        minWidth: 80,
                                                                        borderRadius: '4px',
                                                                        border: "1px solid #FCD6DE",
                                                                        textTransform: 'none',
                                                                        fontSize: '0.75rem',
                                                                        padding: '2px 8px',
                                                                        '&:hover': { bgcolor: '#F8C8D4' }
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    Needs improvement
                                                                </Button>
                                                                <Button
                                                                    onClick={() => setRemarks((prev) => prev + ' Exceptional!')}
                                                                    sx={{
                                                                        bgcolor: '#D2B7E5',
                                                                        color: '#4E148C',
                                                                        height: 24,
                                                                        minWidth: 80,
                                                                        borderRadius: '4px',
                                                                        border: "1px solid #6247AA",
                                                                        textTransform: 'none',
                                                                        fontSize: '0.75rem',
                                                                        padding: '2px 8px',
                                                                        '&:hover': { bgcolor: '#B79CD2' }
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    Exceptional!
                                                                </Button>
                                                            </Box>
                                                        ),
                                                    }}
                                                />
                                            </Box>
                                        )}
                                        {(assignStatus === "rejected" || assignStatus === "reviewed") && (
                                            <Box sx={{ mb: 3, width: "100%" }}>
                                                <TextField
                                                    multiline
                                                    rows={4}
                                                    fullWidth
                                                    label="Remarks"
                                                    name="remarks"
                                                    value={assignment?.remark || 'No Remarks'}
                                                    variant="outlined"
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            bgcolor: '#fff',
                                                            paddingBottom: "40px",
                                                        },
                                                    }}
                                                >
                                                    {assignment?.remark || 'No Remarks'}
                                                </TextField>
                                            </Box>

                                        )}
                                    </Grid>
                                </Grid>
                                {(assignStatus === "submitted") && (
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="contained"
                                            onClick={handleSubmit}
                                            disabled={!status || !selectedMark}
                                            sx={{
                                                bgcolor: '#1976D2',
                                                '&:hover': { bgcolor: '#1565C0' },
                                                textTransform: 'none',
                                                px: 3,
                                                '&.Mui-disabled': {
                                                    bgcolor: '#E0E0E0',
                                                    color: '#9E9E9E'
                                                }
                                            }}
                                        >
                                            SUBMIT & CONTINUE
                                        </Button>
                                    </Box>
                                )}

                            </Box>
                        </Grid>
                    </Grid>

                )}

                {assignment.status === "assigned" && (
                    <Grid container >
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                            <img src={nodata} alt="" style={{ width: "40%", height: "250px", objectFit: "contain" }} />
                            <Typography variant="h5" color="#481E82" >
                                File not found. Waiting for their submission!
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </Box>

            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >

                <Paper elevation="4" sx={{ borderRadius: "0px" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, pt: "0!important" }}>
                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                            File Description
                        </Typography>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>

                        </Toolbar>
                    </Box>
                    <Typography variant="body1" sx={{ px: 3, pt: 0, pb: 2 }}>
                        {assignment.file_description}
                    </Typography>

                    <Box
                        sx={{
                            width: "100%",
                            bgcolor: "#f1f4f9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            mb: 2
                        }}
                    >
                        {(assignment.status === "assigned") && (
                            <Box
                                component="img"
                                src={Nodata}
                                // alt="Project content"
                                sx={{
                                    width: "80%",
                                    height: "100vh",
                                    objectFit: "contain"
                                }}
                            />
                        )}
                        {(assignment.status === "submitted" || assignment.status === "reviewed" || assignment.status === "rejected") && (
                            <Box
                                sx={{
                                    width: "80%",
                                    height: "100vh",
                                    objectFit: "contain"
                                }}
                            >
                                {assignment.input_file_path && assignment.input_file_path.length > 0 ? (
                                    (() => {
                                        // const fileUrl = `http://127.0.0.1:8000/documents/${assignment.input_file_path[currentPage - 1]}`;
                                        // const fileUrl = `http://13.235.83.128:8000/documents/${assignment.input_file_path[currentPage - 1]}`;
                                        // const fileUrl = `http://143.110.191.9/documents/${assignment.input_file_path[currentPage - 1]}`;
                                        const fileName = assignment.input_file_path[currentPage - 1].split('/').pop();
                                        const fileUrl = `https://learn.quraltalent.com/documents/${assignment.input_file_path[currentPage - 1]}`;
                                        // const fileUrl = `http://16.171.0.8/documents/${assignment.input_file_path[currentPage - 1]}`;
                                        const fileExtension = fileUrl.split('.').pop().toLowerCase();

                                        if (["png", "jpg", "jpeg", "gif"].includes(fileExtension)) {
                                            return (
                                                <img
                                                    src={fileUrl}
                                                    alt="Uploaded file"
                                                    style={{ width: "80%", height: "100%", objectFit: "contain" }}
                                                />
                                            );
                                        } else if (fileExtension === "pdf") {
                                            return (
                                                <iframe
                                                    src={fileUrl}
                                                    style={{ width: "100%", height: "100%", border: "none" }}
                                                    title="PDF Viewer"
                                                />
                                            );
                                        } else if (["mp3", "wav", "ogg", "m4a", "aac", "mpeg"].includes(fileExtension)) {
                                            return (
                                                <Box sx={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    p: 3
                                                }}>
                                                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                                                        Audio File: {fileName}{fileUrl}
                                                    </Typography>
                                                    {/* <audio controls src={`http://127.0.0.1:8000/stream-audio/${fileName}`} /> */}
                                                    <audio controls src={`https://learn.quraltalent.com/stream-audio/${fileName}`} />

                                                </Box>
                                            );
                                        } else if (["txt", "csv", "log"].includes(fileExtension)) {
                                            return (
                                                <iframe
                                                    src={fileUrl}
                                                    style={{ width: "100%", height: "100%", border: "none" }}
                                                    title="Text Viewer"
                                                />
                                            );
                                        }
                                        else if (["ppt", "pptx"].includes(fileExtension)) {
                                            return (
                                                <iframe
                                                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
                                                    style={{ width: "100%", height: "600px", border: "none" }}
                                                    title="PowerPoint Viewer"
                                                />
                                            );
                                        }
                                        else {
                                            return <Typography>No preview available for this file type.</Typography>;
                                        }
                                    })()
                                ) : (
                                    <Typography>No file available</Typography>
                                )}
                            </Box>

                        )}
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mt: 2,
                        p: 1
                    }}>
                        {(assignment.status === "submitted" || assignment.status === "reviewd" || assignment.status === "rejected") && (
                            <Stack spacing={2}>
                                {assignment?.input_file_path?.length > 0 && (
                                    <Pagination
                                        count={assignment.input_file_path.length}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        sx={{
                                            '& .MuiPaginationItem-root': { mx: 0.5 },
                                            '& .Mui-selected': { bgcolor: '#9c27b0 !important', color: 'white' },
                                        }}
                                    />
                                )}
                            </Stack>
                        )}
                    </Box>
                </Paper>
            </Dialog>

        </Box >
    );
};

export default ProjectStaffReview;